/**
 * Created by falknisius on 15.06.17.
 */

import messageService from './MessageService'

const DATA_CHANNEL = 'private:equeoqd:'
// init channel
// messageService.getChannel(DATA_CHANNEL)

async function updatePresenceList (channelName) {
  const presentUsers = await messageService.getPresence(channelName)

  const presencesByNickname = presentUsers.reduce((acc, val) => {
    acc[val.data.nickname] = val.data
    return acc
  }, {})

  return presencesByNickname
}

const listeners = {}

export function register (onDataReceivedCallback, groupId) {
  const channelName = `${DATA_CHANNEL}${groupId}`
  messageService.registerChannel(channelName, onDataReceivedCallback)
  messageService.subscribePresence(channelName, () => updatePresenceList(channelName))
  updatePresenceList(channelName)
}

export function unregister (onDataReceivedCallback, groupId) {
  const channelName = `${DATA_CHANNEL}${groupId}`
  if (listeners[groupId]) {
    listeners[groupId]()
  }
  messageService.leavePresence(channelName)
  messageService.unregisterChannel(channelName, onDataReceivedCallback)
  messageService.unsubscribePresence(channelName)
}



// WEBPACK FOOTER //
// ./src/services/QDGroupService.js